<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 页面标题 -->
    <div class="bg-white shadow-sm border-b">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex items-center justify-between h-16">
          <div>
            <h1 class="text-2xl font-bold text-gray-900">{{ $store.getters.t('streamer_workbench') }}</h1>
            <p class="text-sm text-gray-600">{{ $store.getters.t('streamer_workbench_desc') }}</p>
          </div>
          <div class="flex items-center space-x-4">
            <div class="flex items-center space-x-2">
              <div class="w-3 h-3 bg-blue-500 rounded-full animate-pulse"></div>
              <span class="text-sm text-gray-600">{{ $store.getters.t('streamer_workbench_running') }}</span>
            </div>
            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors">
              <i class="fas fa-plus mr-2"></i>
              {{ $store.getters.t('new_streamer') }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <!-- 主播概览卡片 -->
      <div class="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('total_streamers') }}</p>
              <p class="text-2xl font-bold text-gray-900">128</p>
            </div>
            <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-users text-blue-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">{{ $store.getters.t('month_increase') }} 12%</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('online_streamers') }}</p>
              <p class="text-2xl font-bold text-gray-900">45</p>
            </div>
            <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-broadcast-tower text-green-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-green-600 bg-green-100 px-2 py-1 rounded-full">{{ $store.getters.t('online_rate') }} 35%</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('today_training') }}</p>
              <p class="text-2xl font-bold text-gray-900">23</p>
            </div>
            <div class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-graduation-cap text-purple-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-purple-600 bg-purple-100 px-2 py-1 rounded-full">{{ $store.getters.t('completion_rate') }} 18%</span>
          </div>
        </div>

        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm font-medium text-gray-600">{{ $store.getters.t('highlights') }}</p>
              <p class="text-2xl font-bold text-gray-900">156</p>
            </div>
            <div class="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
              <i class="fas fa-star text-yellow-600 text-xl"></i>
            </div>
          </div>
          <div class="mt-4">
            <span class="text-xs text-yellow-600 bg-yellow-100 px-2 py-1 rounded-full">{{ $store.getters.t('week_increase') }} +8%</span>
          </div>
        </div>
      </div>

      <!-- 主要功能区域 -->
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8">
        <!-- 开播前受训 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-graduation-cap mr-2 text-blue-500"></i>
              {{ $store.getters.t('pre_broadcast_training') }}
            </h3>
            <span class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">{{ $store.getters.t('in_progress') }}</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('basic_skills_training') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">{{ $store.getters.t('completed') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('camera_operation') }}, {{ $store.getters.t('lighting_adjustment') }}, {{ $store.getters.t('sound_settings') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('completion_time') }} 2 hours ago</div>
            </div>
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('speech_training') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">{{ $store.getters.t('in_progress') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('opening_line') }}, {{ $store.getters.t('interaction_skills') }}, {{ $store.getters.t('closing_line') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('estimated_completion') }} 30 minutes</div>
            </div>
            <div class="p-4 bg-blue-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('platform_rules_learning') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">{{ $store.getters.t('pending_start') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('platform_broadcast_rules') }}, {{ $store.getters.t('violation_behavior') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('planned_time') }} tomorrow</div>
            </div>
          </div>
        </div>

        <!-- 直播话术 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-comments mr-2 text-green-500"></i>
              {{ $store.getters.t('live_speech') }}
            </h3>
            <button class="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full hover:bg-green-200">
              <i class="fas fa-plus mr-1"></i>
              {{ $store.getters.t('new_speech') }}
            </button>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('opening_speech') }}</span>
                <span class="text-xs bg-green-200 text-green-800 px-2 py-1 rounded">{{ $store.getters.t('popular') }}</span>
              </div>
              <div class="text-sm text-gray-600">"{{ $store.getters.t('welcome_message') }}..."</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('usage_count') }} 156 times</div>
            </div>
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('interaction_speech') }}</span>
                <span class="text-xs bg-blue-200 text-blue-800 px-2 py-1 rounded">{{ $store.getters.t('recommended') }}</span>
              </div>
              <div class="text-sm text-gray-600">"{{ $store.getters.t('thank_you_message') }}..."</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('usage_count') }} 89 times</div>
            </div>
            <div class="p-4 bg-green-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('closing_speech') }}</span>
                <span class="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded">{{ $store.getters.t('normal') }}</span>
              </div>
              <div class="text-sm text-gray-600">"{{ $store.getters.t('end_message') }}..."</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('usage_count') }} 45 times</div>
            </div>
          </div>
        </div>

        <!-- 高光时刻 -->
        <div class="bg-white rounded-lg shadow-sm border p-6">
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-semibold text-gray-900 flex items-center">
              <i class="fas fa-star mr-2 text-yellow-500"></i>
              {{ $store.getters.t('highlights') }}
            </h3>
            <span class="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">{{ $store.getters.t('ai_recognition') }}</span>
          </div>
          <div class="space-y-4">
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('exciting_interaction') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">{{ $store.getters.t('highlight') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('exciting_interaction_snippet') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('duration') }} 2 minutes 30 seconds</div>
            </div>
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('talent_show') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">{{ $store.getters.t('highlight') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('talent_performance_snippet') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('duration') }} 1 minute 45 seconds</div>
            </div>
            <div class="p-4 bg-yellow-50 rounded-lg">
              <div class="flex items-center justify-between mb-2">
                <span class="font-medium text-gray-900">{{ $store.getters.t('funny_moment') }}</span>
                <span class="text-xs bg-yellow-200 text-yellow-800 px-2 py-1 rounded">{{ $store.getters.t('highlight') }}</span>
              </div>
              <div class="text-sm text-gray-600">{{ $store.getters.t('funny_moment_snippet') }}</div>
              <div class="mt-2 text-xs text-gray-500">{{ $store.getters.t('duration') }} 3 minutes 12 seconds</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 主播列表 -->
      <div class="bg-white rounded-lg shadow-sm border p-6 mt-8">
        <div class="flex items-center justify-between mb-6">
          <h3 class="text-lg font-semibold text-gray-900">{{ $store.getters.t('streamer_management') }}</h3>
          <div class="flex space-x-2">
                          <input 
                type="text" 
                :placeholder="$store.getters.t('search_streamer') + '...'" 
                class="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-blue-500"
              >
            <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors text-sm">
              <i class="fas fa-search mr-1"></i>
              {{ $store.getters.t('search') }}
            </button>
          </div>
        </div>
        
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('streamer') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('status') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('training_progress') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('highlights') }}</th>
                <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $store.getters.t('actions') }}</th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60" alt="">
                    <div class="ml-4">
                      <div class="text-sm font-medium text-gray-900">{{ $store.getters.t('little_beauty_streamer') }}</div>
                      <div class="text-sm text-gray-500">{{ $store.getters.t('id') }} 1001</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-green-100 text-green-800">
                    {{ $store.getters.t('live_broadcast') }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-16 bg-gray-200 rounded-full h-2 mr-2">
                      <div class="bg-blue-600 h-2 rounded-full" style="width: 85%"></div>
                    </div>
                    <span class="text-sm text-gray-900">85%</span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">12个</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button @click="viewStreamerDetail('1001')" class="text-blue-600 hover:text-blue-900 mr-3">{{ $store.getters.t('view') }}</button>
                  <button class="text-green-600 hover:text-green-900">{{ $store.getters.t('edit') }}</button>
                </td>
              </tr>
              <tr>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <img class="h-10 w-10 rounded-full" src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60" alt="">
                    <div class="ml-4">
                      <div class="text-sm font-medium text-gray-900">{{ $store.getters.t('strong_streamer') }}</div>
                      <div class="text-sm text-gray-500">{{ $store.getters.t('id') }} 1002</div>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-yellow-100 text-yellow-800">
                    {{ $store.getters.t('training') }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div class="w-16 bg-gray-200 rounded-full h-2 mr-2">
                      <div class="bg-yellow-600 h-2 rounded-full" style="width: 60%"></div>
                    </div>
                    <span class="text-sm text-gray-900">60%</span>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">8个</td>
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <button @click="viewStreamerDetail('1002')" class="text-blue-600 hover:text-blue-900 mr-3">{{ $store.getters.t('view') }}</button>
                  <button class="text-green-600 hover:text-green-900">{{ $store.getters.t('edit') }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StreamerWorkbench',
  data() {
    return {
      // 可以添加数据
    }
  },
  methods: {
    viewStreamerDetail(streamerId) {
      this.$router.push(`/streamer-detail/${streamerId}`)
    }
  }
}
</script>

<style scoped>
/* 可以添加样式 */
</style> 